import { Dispatch } from 'redux';

// API
import {
  fetchAccount,
  fetchLoginStatus as apiFetchLoginStatus,
} from '@tob/shared/account/api';

// Reducer Actions Types
import {
  FETCH_ACCOUNT_INFO,
  FETCH_LOGIN_STATUS,
  BUSINESS_ACCOUNT_INFO,
} from './actionTypes';

// Utils
import getIn from '@shopee/get-in';

// Constants
import { REDUCER_NAME } from './constants';
import { APIProgress, ErrorCode } from '@tob/shared/api-constants';

// Types
import { AccountAction, State } from './types';
import { BusinessAccount } from '@shopee-user/account-constants';

export function fetchAccountInfo({
  forceRefetch = false,
}: {
  forceRefetch?: boolean;
}) {
  return async function (
    dispatch: Dispatch<AccountAction>,
    getState: () => State
  ) {
    const progress = getIn(
      getState(),
      [REDUCER_NAME, 'accountProgress'],
      APIProgress.Init
    );

    const errorCode = getIn(getState(), [REDUCER_NAME, 'accountError']);
    if (
      !forceRefetch &&
      (progress === APIProgress.Requested ||
        progress === APIProgress.Success ||
        (progress === APIProgress.Failed &&
          errorCode === ErrorCode.NotLoggedIn))
    ) {
      return;
    }

    dispatch({
      type: FETCH_ACCOUNT_INFO.REQUESTED,
    });

    const { error, data } = await fetchAccount();

    if (!error && data) {
      dispatch({
        type: FETCH_ACCOUNT_INFO.SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: FETCH_ACCOUNT_INFO.FAILED,
        payload: { error: error || 0 },
      });
    }
  };
}

export function fetchLoginStatus({
  forceRefetch = false,
}: {
  forceRefetch?: boolean;
}) {
  return async function (
    dispatch: Dispatch<AccountAction>,
    getState: () => State
  ) {
    const progress = getIn(
      getState(),
      [REDUCER_NAME, 'loginStatusProgress'],
      APIProgress.Init
    );
    const errorCode = getIn(getState(), [REDUCER_NAME, 'loginStatusError']);
    if (
      !forceRefetch &&
      (progress === APIProgress.Requested ||
        progress === APIProgress.Success ||
        (progress === APIProgress.Failed &&
          errorCode === ErrorCode.NotLoggedIn))
    ) {
      return;
    }

    dispatch({
      type: FETCH_LOGIN_STATUS.REQUESTED,
    });

    const { error, data } = await apiFetchLoginStatus();

    if (!error && data) {
      dispatch({
        type: FETCH_LOGIN_STATUS.SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: FETCH_LOGIN_STATUS.FAILED,
        payload: { error: error || 0 },
      });
    }
  };
}

export function updateAccountInfo(businessAccount: BusinessAccount) {
  return function (dispatch: Dispatch<AccountAction>) {
    dispatch({
      type: BUSINESS_ACCOUNT_INFO.UPDATE,
      payload: {
        account: businessAccount,
      },
    });
  };
}
